import type { DialogUser } from './lib';

export const useUserList = () => {
	const list: DialogUser[] = [
		{ firstName: 'Test1', lastName: 'Test1', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
		{ firstName: 'Test1', lastName: 'Test1', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
		{ firstName: 'Test1', lastName: 'Test1', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
		{ firstName: 'Test1', lastName: 'Test1', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
		{ firstName: 'Test1', lastName: 'Test1', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
		{ firstName: 'Test1', lastName: 'Test1', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
		{ firstName: 'Test1', lastName: 'Test1', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
		{ firstName: 'Test1', lastName: 'Test1', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
		{ firstName: 'Test1', lastName: 'Test1', image: '', status: 'ok' },
		{ firstName: 'Test2', lastName: 'Test2', image: '', status: 'ok' },
	];
	return { list };
};
